// extracted by mini-css-extract-plugin
export var group = "CourseAtGlance-module--group--b0731";
export var label = "CourseAtGlance-module--label--387e4";
export var note = "CourseAtGlance-module--note--b1a83";
export var value = "CourseAtGlance-module--value--7a13b";
export var wrapper = "CourseAtGlance-module--wrapper--dcc14";